import { createSlice, PayloadAction, SliceCaseReducers, SliceSelectors } from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { AccountPaymentType } from 'services/customer/customer.type';

export const customerSliceName = 'customer';

export type CustomerState =
    | {
          brandId: number | null;
          customerName: string | null;
          accessToken: null;
          customerId: null;
          email: null;
          phone: null;
          accountPaymentType: null;
          ewalletOverdraftAmount: null;
      }
    | {
          brandId: number;
          customerName: string;
          accessToken: string;
          customerId: number;
          email: string;
          phone: string;
          accountPaymentType: AccountPaymentType | null;
          ewalletOverdraftAmount: number | null;
      };

const initialState: CustomerState = {
    brandId: null,
    customerName: null,
    accessToken: null,
    customerId: null,
    email: null,
    phone: null,
    accountPaymentType: null,
    ewalletOverdraftAmount: null,
};

export const customerSlice = createSlice<
    CustomerState,
    SliceCaseReducers<CustomerState>,
    string,
    SliceSelectors<CustomerState>
>({
    name: customerSliceName,
    initialState,
    reducers: {
        updateCustomer: (
            state,
            action: PayloadAction<CustomerState | { customerName: string }>,
        ) => ({
            ...state,
            ...action.payload,
        }),
        resetCustomer: (_state, _action: PayloadAction) => ({ ...initialState }),
    },
});

export const getCustomer = (state: RootState) => state.customer;
export const getCustomerBrandId = (state: RootState) => getCustomer(state).brandId;
export const getCustomerName = (state: RootState) => getCustomer(state).customerName;
export const getAccessToken = (state: RootState) => getCustomer(state).accessToken;
export const getCustomerId = (state: RootState) => getCustomer(state).customerId;
export const getEmail = (state: RootState) => getCustomer(state).email;
export const getPhone = (state: RootState) => getCustomer(state).phone;
export const getAccountPaymentType = (state: RootState) => getCustomer(state).accountPaymentType;
export const getEwalletOverdraftAmount = (state: RootState) =>
    getCustomer(state).ewalletOverdraftAmount;

export const { updateCustomer, resetCustomer } = customerSlice.actions;
